<main>
    <div class="d-flex flex-row justify-content-center text-center">
        @if (timeline && this.timeline.owner?.id == this.user.id) {
            <h1 class="m-10 f-18">
                My Timeline
            </h1>
        } @else if (timeline) {
            <h3 class="m-10">
                {{ timeline | nameDisplay: undefined: undefined: 'timeline' }}'s Timeline
            </h3>
        }

    </div>
    <div class="flex-col align-items-center">
        @if (permission && !isRaa) {
            <p [matTooltip]="permission == 'Add but not View or Comment' ? 'Without view access timeline results only include albums you have created': ''"
               class="clear text-center m-10">
                You can
                {{ permission == 'Add but not View or Comment' ? 'Add Only' : (permission | permissionsDisplay| async | lowercase) }}
                <ng-container></ng-container>
            </p>
        }
        @if (this.user && this.user.role.raa_is_limited && this.uploadSession && !this.uploadSession.can_upload) {
            <small class="clear text-center mb-10"> You have used your upload for this period you can next upload
                on {{ parseDate(this.uploadSession?.next_reset, 'YYYY-MM-DD', 'DD/MM/YYYY') }}</small>
        }
        @if (this.user && this.user.role.raa_is_limited && this.uploadSession && this.uploadSession.can_upload) {
            <small class="clear text-center mb-10"> You can create your upload for this period
                until {{ parseDate(this.uploadSession?.next_reset, 'YYYY-MM-DD', 'DD/MM/YYYY') }}</small>
        }
    </div>
    <div class="mediumContainer">
        <div class="d-flex flex-row align-items-center searchRow">
            <mat-form-field appearance="outline" class="w-100 noBottomPadding" color="primary">
                <mat-label>Search</mat-label>
                <input (keyup)="keyup()"
                       [(ngModel)]="searchTerm"
                       matInput
                       type="text"/>
                <button (click)="getTimelineMemories()" (keyup.enter)="getTimelineMemories()" [disabled]="!searchTerm"
                        aria-label="Search"
                        mat-icon-button matPrefix matTooltip="Search Memories">
                    <mat-icon color="primary">
                        search
                    </mat-icon>
                </button>
                @if (searchTerm) {
                    <button (click)="clearSearch()" (keyup.enter)="clearSearch()"
                            aria-label="Clear Search" mat-icon-button matSuffix>
                        <mat-icon>close</mat-icon>
                    </button>
                }
            </mat-form-field>

            @if (showRaaUploadForPeriod()) {
                <div [matTooltip]="getRaaUploadForPeriodTooltip()">
                    <button (click)="newMediaForAPeriod()" (keyup.enter)="newMediaForAPeriod()"
                            aria-label="New upload" class="mat-elevation-z2"
                            color="primary" mat-mini-fab>
                        <mat-icon>
                            add_photo_alternate
                        </mat-icon>
                    </button>
                </div>
            }
            @if (this.user && !this.isRaa) {
                @if (permission == 'View, Comment and Add' || permission == 'Add but not View or Comment') {
                    <button (click)="newMemory()" (keyup.enter)="newMemory()"
                            aria-label="New Album" class="mat-elevation-z2" color="primary"
                            mat-mini-fab matPrefix matTooltip="New Album">
                        <mat-icon>
                            add
                        </mat-icon>
                    </button>
                }
            }
            @if (this.user && this.user.role.role_type == 'admin') {
                <button (click)="exportTimeline()" (keyup.enter)="exportTimeline()"
                        aria-label="Request export" class="mat-elevation-z2" color="primary"
                        mat-mini-fab matPrefix matTooltip="Request export">
                    <mat-icon>
                        cloud_download
                    </mat-icon>
                </button>
            }

            @if (this.user && (this.user.role.name == 'Care Leaver (16-25)' || this.timeline?.has_cioc_ended) && this.timeline?.owner?.id == this.user.id) {
                <button (click)="ExportOwnTimeline()" (keyup.enter)="ExportOwnTimeline()"
                        aria-label="Request export" class="mat-elevation-z2" color="primary"
                        mat-mini-fab matPrefix matTooltip="Request export">
                    <mat-icon>
                        cloud_download
                    </mat-icon>
                </button>
            }
        </div>
        <div class="filtersRow">
            <div>
                <mat-form-field appearance="outline" class="w-100 noBottomPadding" color="primary">
                    <mat-label>Enter a date range</mat-label>
                    <mat-date-range-input [max]="maxDate" [min]="minDate" [rangePicker]="picker">
                        <input (dateInput)="this.dateChange($event)" [formControl]="startDateField" [readonly]="true"
                               matInput
                               matStartDate placeholder="Start date">
                        <input (dateInput)="this.dateChange($event, true)" [formControl]="endDateField"
                               [readonly]="true" matEndDate
                               matInput placeholder="End date">
                    </mat-date-range-input>
                    <mat-datepicker-toggle [for]="picker" matIconSuffix></mat-datepicker-toggle>
                    <mat-date-range-picker #picker></mat-date-range-picker>
                    @if (this.endDate || this.startDate) {
                        <button (click)="clearDate()" (keyup.enter)="clearDate()"
                                aria-label="Clear Date"
                                mat-icon-button matSuffix>
                            <mat-icon>close</mat-icon>
                        </button>
                    }
                    <mat-error>
                        Please enter the date in a dd/mm/yyyy format
                    </mat-error>
                </mat-form-field>
            </div>
            <div>
                <mat-form-field appearance="outline" class="w-100 noBottomPadding" color="primary">
                    <mat-label>Order</mat-label>
                    <select [ngModel]="order" (ngModelChange)="this.page = 0; getTimelineMemories($event)"
                            matNativeControl>
                        <option selected value="desc">Newest - Oldest</option>
                        <option value="asc">Oldest - Newest</option>
                    </select>
                </mat-form-field>
            </div>
            <div>
                <mat-form-field appearance="outline" class="w-100 noBottomPadding" color="primary">
                    <mat-label>Tags</mat-label>
                    <input #tagInput [formControl]="tagSearchControl"
                           [matAutocomplete]="auto"
                           [matChipInputFor]="chipList"
                           matInput
                           placeholder="Select Tags">
                    <mat-autocomplete #auto="matAutocomplete"
                                      (optionSelected)="selectTag($event.option.value)">
                        @for (tag of (filteredTags | async) ?? []; track tag) {
                            @if (!checkIfInArray(tag.id, this.selectedTags)) {
                                <mat-option
                                        [value]="tag.id">
                                    {{ tag.name }}
                                </mat-option>
                            }
                        }
                    </mat-autocomplete>
                </mat-form-field>
                <mat-chip-grid #chipList aria-label="Tags Selection">
                    @for (tag of this.tags; track tag) {
                        @if (this.selectedTags.includes(tag.id)) {
                            <mat-chip (removed)="removeTag(tag.id)"
                                      class="smChip">
                                {{ tag.name }}
                                <button matChipRemove>
                                    <mat-icon>cancel</mat-icon>
                                </button>
                            </mat-chip>
                        }
                    }
                </mat-chip-grid>
            </div>
        </div>
        @if (loading) {
            <mat-progress-bar color="primary" mode="indeterminate"></mat-progress-bar>
        }
        <div class="flex-row justify-content-end mb-10">
            <mat-button-toggle-group name="display" aria-label="display Style" [(ngModel)]="display">
                <mat-button-toggle value="grid">Grid
                    <mat-icon>view_module</mat-icon>
                </mat-button-toggle>
                <mat-button-toggle value="list">List
                    <mat-icon>view_list</mat-icon>
                </mat-button-toggle>
            </mat-button-toggle-group>
        </div>
        @if ((!years || (years.length == 0) || (years.length == 1 && years[0].memories.length < 1)) && !loading) {
            <div aria-live="polite" class="text-center" role="status">
                @if (this.tags.length < 0 || this.endDate || this.startDate || this.searchTerm) {
                    <p>
                        No albums available with selected filters.
                    </p>
                } @else if (this.drafts.length > 0 && this.display == 'grid') {
                    @for (draft of drafts; track draft.id) {
                        <div class="flex-row align-items-center ">
                            <hr class="w-100 h-fit">
                            <h2 class="year">Drafts</h2>
                            <hr class="w-100 h-fit">
                        </div>
                        <div class="memoriesContainer text-start">
                            <!-- Draft memory -->
                            <mat-card (click)="newMediaForAPeriod(draft)"
                                      (keydown.enter)="newMediaForAPeriod(draft)"
                                      (keydown.space)="newMediaForAPeriod(draft)"
                                      [attr.aria-label]="'View Draft:' + draft.title "
                                      [matTooltip]="getDraftTooltip()"
                                      class="clickable" role="button" tabindex="0">
                                <img (contextmenu)="false"
                                     [src]="'assets/images/document.png'"
                                     alt="" class="primaryBg favImage" mat-card-image>
                                <mat-card-header class="flex-space-between">
                                    <mat-card-title>Draft: {{ draft.title }}</mat-card-title>
                                </mat-card-header>
                                <mat-card-content>
                                    <small>{{ draft.created_date | date:'MMM dd' }}</small>
                                </mat-card-content>
                            </mat-card>
                        </div>
                    }
                } @else if (this.display == 'grid') {
                    <p>Looks like there’s no albums in this memory box yet!</p>
                }
            </div>
        }

        @if (display == 'grid') {
            @if (this.user?.role?.role_type == 'admin') {
                <div class="memoriesContainer">
                    <mat-card (keydown.enter)="navigate('/hiddenMedias', this.timeline?.id);"
                              [attr.aria-label]="'View Hidden Media'"
                              [routerLink]="['/hiddenMedias', this.timeline?.id]"
                              class="clickable"
                              role="link"
                              tabindex="0">
                        <img (contextmenu)="false"
                             [src]="'assets/images/yella.svg'"
                             alt="" class="primaryBg favImage" mat-card-image>
                        <mat-card-header class="flex-space-between">
                            <mat-card-title>Hidden Media</mat-card-title>
                        </mat-card-header>
                        <mat-card-content>
                        </mat-card-content>
                    </mat-card>
                </div>
            }
            @if (this.searchResults.length > 0) {
                <div class="memoriesContainer">
                    @for (memory of this.searchResults; track memory) {
                        <mat-card
                                (keydown.enter)="navigate('/memory', memory.id);"
                                [attr.aria-label]="'View Album:' + memory.title " [routerLink]="['/memory', memory.id]"
                                class="clickable"
                                role="link" tabindex="0">
                            <img (contextmenu)="false"
                                 [ngClass]="memory.cover_image_thumbnail_url ? 'squareImage' :'favImage'"
                                 [src]="memory.cover_image_thumbnail_url ||'assets/images/vmb.png' "
                                 alt="" class="primaryBg" mat-card-image>
                            <mat-card-header class="flex-space-between">
                                <mat-card-title>{{ memory.title }}</mat-card-title>
                            </mat-card-header>
                            <mat-card-content>
                                <small>{{ memory.date | date:'MMM dd' }}</small>
                            </mat-card-content>
                        </mat-card>
                    }
                </div>
            } @else {
                <div (scrolled)="triggerInfiniteScroll()"
                     [infiniteScrollDistance]="1"
                     [infiniteScrollThrottle]="50"
                     infiniteScroll>
                    @for (year of years; track year; let first = $first) {
                        @if (year.memories.length > 0) {
                            <div class="flex-row align-items-center">
                                <hr class="w-100 h-fit">
                                <h2 class="year">{{ year.year == 0 ? 'Undated' : year.year }}</h2>
                                <hr class="w-100 h-fit">
                            </div>
                            <div class="memoriesContainer">

                                @if (first) {
                                    @if (this.permission !== 'Add but not View or Comment' && !this.isRaa) {
                                        <mat-card (keydown.enter)="this.timeline?.owner?.id == this.user.id ? navigate('/favourites') : navigate('/favourites', this.timeline?.owner?.id);"
                                                  [attr.aria-label]="'View Favourites'"
                                                  [routerLink]="this.timeline?.owner?.id == this.user.id ? ['/favourites' ] : ['/favourites' , this.timeline?.owner?.id] "
                                                  class="clickable" role="link" tabindex="0">
                                            <img (contextmenu)="false"
                                                 [ngClass]="favouritesThumbnail ? 'squareImage' :'favImage'"
                                                 [src]="favouritesThumbnail"
                                                 alt="" class="primaryBg" mat-card-image>
                                            <mat-card-header class="flex-space-between">
                                                <mat-card-title>Favourite Memories</mat-card-title>
                                            </mat-card-header>
                                            <mat-card-content>
                                            </mat-card-content>
                                        </mat-card>
                                    }
                                    @for (draft of drafts; track draft.id) {
                                        <!-- Draft memory -->
                                        <mat-card (click)="newMediaForAPeriod(draft)"
                                                  (keydown.enter)="newMediaForAPeriod(draft)"
                                                  (keydown.space)="newMediaForAPeriod(draft)"
                                                  [attr.aria-label]="'View Draft:' + draft.title "
                                                  [matTooltip]="getDraftTooltip()"
                                                  class="clickable" role="button" tabindex="0">
                                            <img (contextmenu)="false"
                                                 [src]="'assets/images/document.png'"
                                                 alt="" class="primaryBg favImage" mat-card-image>
                                            <mat-card-header class="flex-space-between">
                                                <mat-card-title>Draft: {{ draft.title }}</mat-card-title>
                                            </mat-card-header>
                                            <mat-card-content>
                                                <small>{{ draft.created_date | date:'MMM dd' }}</small>
                                            </mat-card-content>
                                        </mat-card>
                                    }
                                }
                                @for (memory of year.memories; track memory) {
                                    <!--  Normal memory -->
                                    <mat-card (keydown.enter)="navigate('/memory', memory.id);"
                                              [attr.aria-label]="'View Album:' + memory.title"
                                              [routerLink]="['/memory', memory.id]"
                                              class="clickable" role="link" tabindex="0">
                                        <img (contextmenu)="false"
                                             [ngClass]="memory.cover_image_thumbnail_url? 'squareImage' :'favImage'"
                                             [src]="memory.cover_image_thumbnail_url||'assets/images/vmb.png' "
                                             alt="" class="primaryBg" mat-card-image>
                                        <mat-card-header class="flex-space-between">
                                            <mat-card-title>{{ memory.title }}</mat-card-title>
                                        </mat-card-header>
                                        <mat-card-content>
                                            <small>{{ memory.date | date:'MMM dd' }}</small>
                                        </mat-card-content>
                                    </mat-card>
                                }
                            </div>
                        }
                    }
                </div>
            }
        } @else {
            @if (this.drafts.length > 0) {
                <div class="mb-20">
                    <div class="flex-row align-items-center">
                        <hr class="w-100 h-fit">
                        <h2 class="year">Drafts</h2>
                        <hr class="w-100 h-fit">
                    </div>
                    <div class="curvyTable">
                        <table [dataSource]="draftTableSource" class="massiveTable timelineTable" mat-table>
                            <ng-container matColumnDef="img">
                                <th *matHeaderCellDef mat-header-cell></th>
                                <td *matCellDef="let memory" mat-cell>
                                    <img [alt]="memory.title"
                                         class="smallProfilePicture"
                                         src="assets/images/document.png">
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="name">
                                <th *matHeaderCellDef mat-header-cell> Name</th>
                                <td *matCellDef="let memory" mat-cell><b
                                        class="d-none columnTitle">Name:</b> {{ memory.title }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="date">
                                <th *matHeaderCellDef mat-header-cell> Date</th>
                                <td *matCellDef="let memory" mat-cell><b
                                        class="d-none columnTitle">Date:</b> {{ memory.created_date | date:'MMM dd' }}
                                </td>
                            </ng-container>
                            <tr *matHeaderRowDef="draftDisplayedColumns" mat-header-row></tr>
                            <tr (click)="newMediaForAPeriod(memory)"
                                (keydown.enter)="newMediaForAPeriod(memory)"
                                (keydown.space)="newMediaForAPeriod(memory)"
                                *matRowDef="let memory; columns: draftDisplayedColumns;"
                                [attr.aria-label]="'View ' + memory.title"
                                mat-row role="button" tabIndex="0">
                            </tr>
                        </table>
                    </div>
                </div>
            }
            @if (this.memoryTableSource.data.length > 0) {
                <div class="flex-row align-items-center">
                    <hr class="w-100 h-fit">
                    <h2 class="year">Albums</h2>
                    <hr class="w-100 h-fit">
                </div>

                <div (scrolled)="triggerInfiniteScroll()"
                     [infiniteScrollDistance]="1"
                     [infiniteScrollThrottle]="50"
                     class="curvyTable" infiniteScroll>
                    <table [dataSource]="memoryTableSource" class="massiveTable timelineTable" mat-table>
                        <ng-container matColumnDef="img">
                            <th *matHeaderCellDef mat-header-cell></th>
                            <td *matCellDef="let memory" mat-cell>
                                <img [alt]="memory.title"
                                     [src]="getListImage(memory)"
                                     class="smallProfilePicture">
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="name">
                            <th *matHeaderCellDef mat-header-cell> Name</th>
                            <td *matCellDef="let memory" mat-cell><b
                                    class="d-none columnTitle">Name:</b> {{ memory.title }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="creator">
                            <th *matHeaderCellDef mat-header-cell> Creator</th>
                            <td *matCellDef="let memory" mat-cell><b
                                    class="d-none columnTitle">Creator:</b> {{ getListCreator(memory) }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="date">
                            <th *matHeaderCellDef mat-header-cell> Date</th>
                            <td *matCellDef="let memory" mat-cell><b
                                    class="d-none columnTitle">Date:</b> {{ memory.date | date:'MMM dd' }}
                            </td>
                        </ng-container>
                        <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
                        <tr (keydown.enter)="openListItem(memory)" *matRowDef="let memory; columns: displayedColumns;"
                            [attr.aria-label]="'View ' + memory.title"
                            [routerLink]="getListRouterLink(memory)"
                            mat-row
                            tabindex="0"></tr>
                    </table>
                </div>
            }
        }
        @if (paginationLoading) {
            <mat-progress-bar color="primary" mode="indeterminate"></mat-progress-bar>
        }
    </div>
</main>
